import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Frequently Asked <span className="text-primary-500">Questions</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            Everything you need to know about Superbuy Spreadsheets
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-950 pr-4">{item.question}</span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96 pb-4 px-5" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}